import { render, staticRenderFns } from "./ChangePW.vue?vue&type=template&id=4fcc71c6&scoped=true&"
import script from "./ChangePW.vue?vue&type=script&lang=js&"
export * from "./ChangePW.vue?vue&type=script&lang=js&"
import style0 from "./ChangePW.vue?vue&type=style&index=0&id=4fcc71c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcc71c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VRow,VTextField})
